import { RowDataReview } from "../../components/ReviewPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the ReviewTable factory
 */
class ReviewRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/review/read-range"
        this.accessData = "reviews"
    }

    create(review: any): RowDataReview {
        const rowDataReview: RowDataReview = {
            id: review.id,
            fullname: review.fullname,
            review: review.review,
            rating: review.rating,
            reviewDate: review.reviewDate,

            show: review.show,
            action: "",
        };
        return rowDataReview;
    }
}

let reviewRow: ReviewRow | null = null;

export default function getReviewRow(): ReviewRow {
    if (reviewRow === null)
        reviewRow = new ReviewRow()
    return reviewRow
}